import { spacing, Text } from '@scality/core-ui';
import { Box } from '@scality/core-ui/dist/next';
import type React from 'react';
import { Navigate, useLocation } from 'react-router';
import { useDashboardTemplates } from '../hooks/useDashboards';

/**
 * `/dashboards` index: jump to the first dashboard so the user always lands on a
 * canvas; otherwise an empty state (the sidebar lists what's available).
 *
 * The redirect keeps the query string, so filters on a `/dashboards?…` link survive it.
 */
export const DashboardHome: React.FC = () => {
  const { data: templates } = useDashboardTemplates();
  const { search } = useLocation();

  if (templates && templates.length > 0) {
    return <Navigate to={{ pathname: templates[0].id, search }} replace />;
  }
  return (
    <Box display="flex" justifyContent="center" padding={spacing.r16} marginTop="var(--header-height)">
      <Text color="textSecondary">No dashboards available.</Text>
    </Box>
  );
};
